export default __webpack_public_path__ + "static/electrical_motor_b.ee78f8243d0c9d7f076f9821bcbbff93.svg";